import API from "@vahak/core/dist/_services/const";
import useVahakHttpClient from "@vahak/core/dist/hooks/useVahakHttpClient";
import queryNames from "./queryNames";
import { useVahakMutationQuery } from "@vahak/core/dist/hooks/useVahakQueryClient";

// Upload Image
interface UploadImageParams {
    file: File | Blob | undefined;
    operation: string;
}

interface UploadImagePayloadType {
    file: File | Blob | undefined;
    operation: string;
}

export interface UploadImageResponseType {
    data: { path: string };
}

export function useUploadImageService() {
    const { POST } = useVahakHttpClient();
    async function uploadImage({ file, operation }: UploadImageParams) {
        const payload: UploadImagePayloadType = {
            file: file,
            operation: operation
        };

        const customHeaders = {
            "Content-Type": "multipart/form-data"
        };
        const formData = new FormData();
        if (file) {
            formData.append("file", file);
        }
        formData.append("operation", operation);

        return POST<UploadImagePayloadType, UploadImageResponseType>(
            `${API.MISC_UPLOAD_IMAGE}`,
            payload,
            formData,
            {},
            customHeaders
        );
    }

    return useVahakMutationQuery<UploadImageResponseType, unknown, UploadImageParams>(
        [queryNames.uploadImage],
        uploadImage
    );
}
